<template>
  <div class="relative-position">
    <q-img
      :src="imageUrl"
      class="drop-image"
      :style="{ minHeight: minHeight }"
      :class="{ dragover: dragover, 'light-dimmed': disable, 'cursor-not-allowed': disable, 'cursor-pointer': !disable }"
      dropzone
      :error="true"
      @drop.prevent.stop="drop"
      @dragover.prevent.stop="dragEnter"
      @dragenter.prevent.stop="dragEnter"
      @dragleave.prevent.stop="dragLeave"
      @mouseenter.prevent.stop="dragEnter"
      @mouseleave.prevent.stop="dragLeave"
      @click.stop="$refs.file.click()"
    >
      <q-inner-loading :showing="loading" />
      <div
        v-if="!loading && !disable && dragover"
        class="absolute-full text-subtitle2 flex flex-center"
        style="pointer-events: none;padding:10px;"
      >
        Click Or Drop Image Here
      </div>
      <div
        v-if="!loading && !disable && !dragover && !imageUrl"
        class="absolute-full text-subtitle2 flex flex-center bg-white text-black"
        style="pointer-events: none;padding:10px;"
      >
        Click Or Drop Image Here
      </div>
    </q-img>
    <q-btn
      v-if="!loading && !disable && imageUrl"
      style="position: absolute; right: 5px; top: 5px;"
      class="pull-right z-max"
      icon="close"
      color="white"
      text-color="black"
      round
      @click="update(null)"
    />
    <input
      v-show="false"
      ref="file"
      type="file"
      :disabled="disable"
      @change="fileSelected"
    >
    <slot />
  </div>
</template>

<script>

export default {
  name: 'ImageUploader',
  props: {
    modelValue: {
      type: String,
      required: false,
      default: null
    },
    imageUrl: {
      type: String,
      required: false,
      default: null
    },
    minHeight: {
      type: String,
      required: false,
      default: '60px'
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['loading', 'update:model-value'],
  data () {
    return {
      dragover: false,
      loading: false
    }
  },
  methods: {
    update (value) {
      this.$emit('update:model-value', value)
    },
    fileSelected (event) {
      const file = event.target.files[0]

      if (!file) return

      this.upload(file)
    },
    drop (event) {
      event.preventDefault()
      const file = event.dataTransfer.files[0]

      if (!file) return

      this.upload(file)
    },
    async upload (file) {
      this.loading = true
      this.$emit('loading', true)

      const { key } = await this.$directUpload.uploadFile(file, true)

      this.update(key)

      this.$emit('loading', false)
      this.loading = false
      this.dragover = false
    },
    dragEnter () {
      this.dragover = true
    },
    dragLeave () {
      this.dragover = false
    }
  }
}

</script>

<style lang="scss" scoped>
.drop-image {
  border: solid 2px black;
}
.dragover {
  border-color: transparent;
  outline: dotted 3px red !important;
}
</style>
